export const logoutButtonStyles = {
	button: (noAutoSpacing: boolean) => ({
		color: 'orange.contrastText',
		width: 'min-content',
		textTransform: 'capitalize',
		fontSize: '0.875rem',
		fontWeight: 700,
		marginLeft: noAutoSpacing ? 'unset ' : 'auto',
		flex: '0 0 auto'
	})
};
